import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': 'Sprache',
  'common.download.action': 'Herunterladen',
  'common.store.appleprefix': 'Laden im',
  'common.store.googleprefix': 'JETZT BEI',
  'seo.home.title': 'Happy Pets | KI-Begleiter, Selbsttests & Pet-Widgets',
  'seo.home.description': 'Entdecke einen KI-Haustierbegleiter für tägliche Reflexion, Persönlichkeitstests, Tarot, Träume, interaktive Widgets und gemeinsame Pflege mit Freunden.',
  'seo.home.keywords': 'Happy Pets, KI Begleiter, virtuelles Haustier, Pet Widget, Persönlichkeitstest, MBTI, KI Tarot',
  'seo.invite.title': 'Happy Pets Einladung | Virtuelles Haustier gemeinsam pflegen',
  'seo.invite.description': 'Öffne deine Happy-Pets-Einladung und adoptiere oder pflege mit Freunden ein virtuelles Haustier auf iPhone und Android.',
  'nav.skills.label': 'Fähigkeiten',
  'nav.tests.label': 'Tests',
  'nav.guidance.label': 'KI-Impulse',
  'nav.features.label': 'Funktionen',
  'nav.experience.label': 'Erlebnis',
  'nav.community.label': 'Community',
  'nav.news.label': 'Neuigkeiten',
  'home.hero.titlelead': 'Ein kleines Haustier,',
  'home.hero.titleaccent': 'jeden Tag ein wenig Hilfe',
  'home.hero.subtitle': 'Adoptiere ein gemütliches virtuelles Haustier für deinen Bildschirm. Es wächst mit dir und lernt nützliche Fähigkeiten für Alltag, Spaß und leichte Gesellschaft.',
  'home.tools.eyebrow': 'Pet-Fähigkeiten',
  'home.tools.title': 'Alltagsaufgaben, bei denen dein Haustier hilft',
  'home.tools.description': 'Dein Haustier unterstützt dich bei Reflexion, Essensideen, Persönlichkeitseinblicken und kleinen Alltagsentscheidungen.',
  'home.tools.action': 'Jetzt testen',
  'tool.tarot.tag': 'Reflexion',
  'tool.tarot.title': 'Tarot',
  'tool.tarot.description': 'Lass dein Haustier eine Karte ziehen und deine Frage aus einer neuen Perspektive betrachten.',
  'tool.mbti.tag': 'Persönlichkeit',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Erkunde mit deinem Haustier deinen Typ, deine Muster und wie du denkst und Beziehungen gestaltest.',
  'tool.chef.tag': 'Küche',
  'tool.chef.title': 'Kühlschrank-Koch',
  'tool.chef.description': 'Verwandle vorhandene Zutaten mit deinem cleveren kleinen Haustierkoch in einfache Mahlzeiten.',
  'tool.fortune.tag': 'Täglich',
  'tool.fortune.title': 'Tageshoroskop',
  'tool.fortune.description': 'Starte mit einem leichten Blick auf Stimmung, Glück und die kleinen Momente des Tages.',
  'tool.calorie.tag': 'Gesundheit',
  'tool.calorie.title': 'Kalorienrechner',
  'tool.calorie.description': 'Schätze Kalorien, erkenne Ernährungsmuster und entscheide leichter, was auf den Teller kommt.',
  'tool.dream.tag': 'Träume',
  'tool.dream.title': 'Traumdeutung',
  'tool.dream.description': 'Dein Haustier ordnet Traumsymbole und macht aus verschwommenen Bildern Themen zum Nachdenken.',
  'home.assessments.eyebrow': 'Lerne dich besser kennen',
  'home.assessments.title': 'Selbsttests mit Ergebnissen zum Weiterdenken',
  'home.assessments.description': 'Mach einen Test zu Persönlichkeit, Logik, Beruf oder Beziehungen und besprich das Ergebnis anschließend mit deinem KI-Begleiter.',
  'home.assessments.action': 'Test starten',
  'home.assessments.disclaimer': 'Diese Tests dienen Selbstreflexion und Unterhaltung. Sie ersetzen keine medizinische Diagnose oder professionelle Beratung.',
  'assessment.mbti.eyebrow': 'Persönlichkeit',
  'assessment.mbti.title': 'MBTI-Persönlichkeitstest',
  'assessment.mbti.description': 'Erkunde Vorlieben, Kommunikationsstil, Stärken und Entwicklungsmuster in einem ausführlichen Persönlichkeitstest.',
  'assessment.mbti.meta': '108 Fragen',
  'assessment.sbti.eyebrow': 'Sozialer Stil',
  'assessment.sbti.title': 'SBTI-Persönlichkeitstest',
  'assessment.sbti.description': 'Entdecke über fünf spielerische Dimensionen, wie du mit Emotionen, Handlungen und sozialer Energie umgehst.',
  'assessment.sbti.meta': '62 Fragen',
  'assessment.iq.eyebrow': 'Logik',
  'assessment.iq.title': 'IQ-Logiktest',
  'assessment.iq.description': 'Löse nonverbale Muster und vergleiche verschiedene Bereiche des logischen Denkens.',
  'assessment.iq.meta': 'Visuelles Denken',
  'assessment.holland.eyebrow': 'Beruf',
  'assessment.holland.title': 'Holland-Berufsinteressen',
  'assessment.holland.description': 'Finde über sechs Interessentypen heraus, welche Tätigkeiten und Arbeitsumgebungen zu dir passen könnten.',
  'assessment.holland.meta': 'Berufsinteressen',
  'assessment.attachment.eyebrow': 'Beziehungen',
  'assessment.attachment.title': 'Bindungsstil-Test',
  'assessment.attachment.description': 'Reflektiere Nähe, Vertrauen, Sicherheit und Unabhängigkeit, um deine Beziehungsmuster besser zu verstehen.',
  'assessment.attachment.meta': 'Beziehungseinblick',
  'home.guidance.eyebrow': 'Ein sanftes tägliches Ritual',
  'home.guidance.title': 'Mystische KI-Impulse mit Fokus auf Reflexion',
  'home.guidance.description': 'Tarot, Tagesimpulse und Traumsymbole helfen dir, langsamer zu werden, Gefühle zu benennen und einen machbaren nächsten Schritt zu finden. Es geht nicht um Gewissheit, sondern um mehr Klarheit und Ruhe.',
  'guidance.tarot.title': 'KI-Tarot',
  'guidance.tarot.description': 'Wähle Karten zu einer Frage und nutze die Deutung als sanften Impuls für Perspektive und deinen nächsten Schritt.',
  'guidance.tarot.note': 'Für Reflexion und Unterhaltung',
  'guidance.fortune.title': 'Tageshoroskop',
  'guidance.fortune.description': 'Beginne den Tag mit einem leichten Blick auf Stimmung, Energie, Glück und praktische Ermutigung.',
  'guidance.fortune.note': 'Jeden Tag ein neuer Impuls',
  'guidance.dream.title': 'Traumdeutung',
  'guidance.dream.description': 'Verwandle Bilder und Gefühle aus deinen Träumen in Themen zum Erkunden, nicht in feste Vorhersagen.',
  'guidance.dream.note': 'Symbole, Gefühle und Reflexion',
  'home.features.eyebrow': 'Nützliche Fähigkeiten, tägliche Freude',
  'home.features.title': 'Warum dein Haustier so hilfreich wird',
  'feature.raise.title': 'Süße Haustiere großziehen',
  'feature.raise.description': 'Füttere und spiele mit ihnen und sieh zu, wie sie zu niedlichen, tröstenden und hilfreichen Begleitern werden.',
  'feature.hatch.title': 'Neue Fähigkeiten ausbrüten',
  'feature.hatch.description': 'Sammle Eier und entdecke einzigartige Haustiere mit eigener Persönlichkeit und nützlichen Fähigkeiten.',
  'feature.coraising.title': 'Gemeinsam mit Freunden',
  'feature.coraising.description': 'Ladet Freunde zur gemeinsamen Pflege ein: doppelte Liebe, doppelter Spaß.',
  'feature.status.title': 'Täglicher Status',
  'feature.status.description': 'Halte fest, wie es dir geht, und teile deine Gefühle mit deinem Haustier.',
  'feature.frequency.title': 'Tägliche Häufigkeit',
  'feature.frequency.description': 'Erstelle eigene Ereignisse und verfolge Gewohnheiten wie Wassertrinken oder Laufen.',
  'feature.cleaner.title': 'Foto-Bereinigung',
  'feature.cleaner.description': 'Räume spielerisch deine Galerie auf. Unterhaltsam und produktiv.',
  'feature.skills.title': 'KI-Fähigkeitenraum',
  'feature.skills.description': 'Schalte neue Looks frei und entdecke mehr Hilfe bei Reflexion, Planung und Alltagsmomenten.',
  'feature.widget.title': 'Interaktives Widget',
  'feature.widget.description': 'Mit interaktiven Startbildschirm-Widgets bleibt dein Haustier immer in deiner Nähe.',
  'home.steps.eyebrow': 'Erste Schritte',
  'home.steps.title': 'Brüte ein Haustier mit nützlichen Fähigkeiten aus',
  'step.adopt.title': 'Adoptieren',
  'step.adopt.description': 'Wähle dein einzigartiges Ei und beginne deine Reise mit einem eigenen Begleiter.',
  'step.grow.title': 'Wachsen',
  'step.grow.description': 'Füttere, spiele und interagiere täglich, damit dein Haustier wächst und neue Fähigkeiten lernt.',
  'step.together.title': 'Gemeinsam',
  'step.together.description': 'Lade Freunde ein und lass eure Haustiere eine Welt voller Persönlichkeit und Unterstützung teilen.',
  'home.reviews.eyebrow': 'Community',
  'home.reviews.title': 'Beliebt für mehr als nur Niedlichkeit',
  'home.reviews.role': 'Pet-Elternteil',
  'home.news.eyebrow': 'Neuigkeiten & Geschichten',
  'home.news.title': 'Neueste Beiträge',
  'home.news.description': 'Sanfte Ideen für das Leben mit deinem Pet, Selbstentdeckung und mehr Wohlbefinden im Alltag.',
  'home.news.readarticle': 'Artikel lesen',
  'home.news.exploreall': 'Alle Neuigkeiten',
  'review.one.text': 'Mein Haustier ist süß, aber am meisten überrascht mich, wie oft ich seine kleinen Alltagsfähigkeiten nutze.',
  'review.two.text': 'Die gemeinsame Pflege mit meinem Freund macht uns Freude, und die Zusatzfunktionen sind jeden Tag nützlich.',
  'review.three.text': 'Die Widgets sind so interaktiv. Ich liebe den süßen Begleiter auf meinem Startbildschirm, der mir auch im Alltag hilft.',
  'home.footer.tagline': 'Bring Freude und Gesellschaft auf deinen Startbildschirm.',
  'home.footer.product': 'Produkt',
  'home.footer.support': 'Support',
  'home.footer.social': 'Social',
  'home.footer.skills': 'Pet-Fähigkeiten',
  'home.footer.features': 'Funktionen',
  'home.footer.widgets': 'Widgets',
  'home.footer.help': 'Hilfe-Center',
  'home.footer.privacy': 'Datenschutz',
  'home.footer.terms': 'Nutzungsbedingungen',
  'home.footer.copyright': '© 2024 Happy Pet. Alle Rechte vorbehalten.',
  'home.image.logoalt': 'Happy-Pets-Logo',
  'home.image.screenalt': 'Happy-Pets-App-Bildschirm',
  'home.image.enlargedalt': 'Vergrößerter Happy-Pets-Bildschirm',
  'home.image.close': 'Bild schließen',
  'invite.headline': 'Freunde laden dich ein, gemeinsam ein Haustier großzuziehen!',
  'invite.description': 'Nimm die Einladung an und das Ei schlüpft sofort. Füge dein Haustier deinem Startbildschirm hinzu.',
  'invite.download': 'Herunterladen',
  'invite.loadingalt': 'Happy Pets wird geladen',
  'invite.screensalt': 'Screenshots der Happy-Pets-App'
})
